<template>
  <div>
    <v-container v-if="!headers">
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="accent"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-container>
    <material-card
      v-show="headers !== null && headers !== undefined"
      elevation="0"
    >
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="t4a-report"
        @itemsChanged="setData($event)"
        :identifier="identifier"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import {
  ODataHeader,
  ODataCustom,
  ODataEquals,
  ODataGreaterThan,
  ODataLowerThan,
  ODataGreaterThanOrEquals,
  ODataLowerThanOrEquals,
  ODataString,
  ODataInteger,
} from "pbas-vue-components";
import { translate2 } from "../trans2";

export default {
  name: "t4areporttable",
  components: {
    ErrorHandler,
  },
  props: ["url", "year", "identifier"],
  data() {
    return {
      error: null,
      headers: null,
      items: [],
      provider: undefined,
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  watch: {
    url: {
      handler(v) {
        if (v) this.loadPlanData();
      },
    },
  },
  async mounted() {
    this.loadPlanData();
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("plansMembers", ["getCoveragePerYear", "getT4AColumns"]),
    ...mapActions("common", ["createOdataType"]),
    async loadPlanData() {
      try {
        let headers = (await this.getT4AColumns(this.selectedPlan.Id)).data;
        this.headers = this.$helpers.createOdataHeaders(headers, "headers.t4a.");
        let coverage = (await this.getCoveragePerYear({
          plan: this.selectedPlan.Id,
          year: this.year,
        })).data.value;
        for (let c of coverage) {
          let ch = new ODataHeader({
            title: translate2(c, "Name"),
            type: new ODataCustom("TaxedPremiums[]/Coverage/Name", {
              getString: (item, type) => {
                return this.coverageDisplayFunc(c.Name, item);
              },
              getWildcardFilter: (search) => {
                return `TaxedPremiums/any(_taxedPremiums:contains(cast(_taxedPremiums/TotalBeforeTax,'Edm.String'),'${search.toLowerCase()}') and _taxedPremiums/Coverage/Name eq '${encodeURIComponent(
                  c.Name
                )}')`;
              },
              getFilter: (callback) => {
                const res = callback("_taxedPremiums/TotalBeforeTax");
                return `TaxedPremiums/any(_taxedPremiums: ${res} and _taxedPremiums/Coverage/Name eq '${
                  c.Name
                }')`;
              },
              operators: [
                new ODataEquals(),
                new ODataGreaterThan(),
                new ODataLowerThan(),
                new ODataGreaterThanOrEquals(),
                new ODataLowerThanOrEquals(),
              ],
            }),
            sortable: false,
            visible: true,
            searchable: true,
            version: 6,
          });
          this.headers.splice(this.headers.length - 4, 0, ch);
        }
        this.provider = new PbasOData(this.$axiosHttp, this.url, this.headers);
        this.provider.filter = "Total ge 25";
      } catch (error) {
        this.error = error;
      }
    },
    setData(items) {
      this.items = items;
    },
    coverageDisplayFunc(coverage, item) {
      //console.log(coverage, item.TaxedPremiums)
      let taxed = item.TaxedPremiums.filter(
        (o) => o.Coverage.Name === coverage
      );
      if (taxed.length == 0) return "";
      let value = taxed[0].TotalBeforeTax;
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },
  },
};
</script>
